import React from 'react';
import PropTypes from 'prop-types';

import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumChart from '@hydra/common/criterium/CriteriumChart';
import { GoogleAnalyticsDataAuthWrapper } from '@hydra/common/components/GoogleAnalytics/GoogleAnalyticsDataWrapper';
import getGraphData from '@hydra/utils/getGraphData';
import { useI18n } from '@hydra/common/components/i18n';
import ReviewSkeleton from '@hydra/common/components/ReviewSkeleton';

const monthlyReport = {
  reportType: 'ga',
  query: {
    metrics: 'ga:sessions',
    dimensions: 'ga:yearmonth, ga:medium',
    filters: 'ga:medium==(none),ga:medium==organic,ga:medium==referral,ga:medium==extension,ga:medium==cpc',
    'end-date': 'today',
    'start-date': '365daysAgo'
  }
};

function convertData (rows, moment) {
  function extractType (type, rows) {
    if (!rows || rows.length === 0) {
      const month = moment(new Date()).format('MMM YY');
      return [{ x: 0, y: 0, month }];
    }
    return rows
      .filter(([googleDate, rowType]) => rowType === type)
      .map(([googleDate, rowType, sessions]) => getGraphData({ x: googleDate, y: sessions || 0 }));
  }

  const chartData = [
    {
      name: 'organic',
      data: extractType('organic', rows)
    },
    {
      name: 'direct',
      data: extractType('(none)', rows)
    },
    {
      name: 'referral',
      data: extractType('referral', rows)
    },
    {
      name: 'extension',
      data: extractType('extension', rows)
    },
    {
      name: 'cpc',
      data: extractType('cpc', rows)
    }
  ];
  return chartData;
}

function SourceGraph ({ data }) {
  const { moment } = useI18n();
  const chartData = convertData(data, moment);
  return (
    <CriteriumChart
      type='line'
      frequency='month'
      hasLegend
      hasTooltip
      data={chartData}
    />
  );
}

export const PjGaSource = ({ criterium, url }) => {
  return (
    <Criterium
      criterium={criterium || { type: 'pj_ga_source', score: null, importance: 0, solvability: 0 }}
      variables={{ url }}
      clickable={!!criterium}
    >
      {criterium
        ? (
          <GoogleAnalyticsDataAuthWrapper
            accessToken={criterium.data && criterium.data.accessToken}
            viewId={criterium.data && criterium.data.viewId}
            report={monthlyReport}
            Component={SourceGraph}
            loadingComponent={<ReviewSkeleton height={300} />}
          />
          )
        : <ReviewSkeleton height={300} />}
    </Criterium>
  );
};

PjGaSource.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      viewId: PropTypes.string,
      accessToken: PropTypes.string
    })
  })
};

export default React.memo(PjGaSource);
